import styled from 'styled-components';
import { themeVar } from '@/styles/theme';

export interface IToggle {
  title: string;
  isActive: boolean;
  onToggle: () => void;
  'data-testid'?: string;
}

export const Toggle = ({ title, isActive, onToggle, 'data-testid': testId }: IToggle) => {
  return (
    <ToggleContainer>
      <ToggleTitle>{title}</ToggleTitle>
      <ToggleWrapper data-testid={testId} onClick={onToggle} isActive={isActive}>
        <IconWrapper isActive={isActive}>
          {isActive ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10.006 1.79903e-06C8.02766 -0.0011846 6.09346 0.584449 4.44806 1.68281C2.80265 2.78116 1.51999 4.3429 0.76237 6.1704C0.00475063 7.99791 -0.193806 10.0091 0.191855 11.9494C0.577515 13.8898 1.53003 15.6722 2.92892 17.0711C4.3278 18.4699 6.11019 19.4225 8.05056 19.8081C9.99092 20.1938 12.0021 19.9953 13.8296 19.2376C15.6571 18.48 17.2188 17.1974 18.3172 15.552C19.4156 13.9066 20.0012 11.9723 20 9.99399C19.9984 7.34391 18.9449 4.80283 17.071 2.92894C15.1972 1.05504 12.6561 0.00159106 10.006 1.79903e-06ZM10.006 17.9964C8.42301 17.9976 6.87525 17.5293 5.55848 16.6507C4.2417 15.7721 3.21507 14.5227 2.60847 13.0605C2.00187 11.5984 1.84252 9.98921 2.15062 8.4365C2.45871 6.88379 3.2204 5.45733 4.33931 4.33758C5.45823 3.21782 6.88413 2.45508 8.43661 2.14582C9.98909 1.83656 11.5984 1.99468 13.061 2.60018C14.5236 3.20569 15.7737 4.23138 16.6533 5.54749C17.5329 6.86361 18.0024 8.41102 18.0024 9.99399C17.9992 12.1143 17.1559 14.1471 15.6572 15.6469C14.1584 17.1468 12.1263 17.9916 10.006 17.9964ZM14.5951 5.57889L7.9964 12.1776L5.41092 9.59807L4.00118 11.0078L7.9964 15.009L15.9988 7.00661L14.5951 5.57889Z"
                fill={themeVar('font.action')}
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M18.8872 8.9982L15.009 12.8765L11.1218 8.9982L9.00721 11.1488L12.8944 15.027L9.00721 18.9142L11.1218 21.0288L15.009 17.1416L18.8872 21.0288L21.0018 18.9142L17.1236 15.027L21.0018 11.1488L18.8872 8.9982ZM15.009 2.70395e-06C12.0415 -0.0017769 9.14018 0.876674 6.67207 2.52421C4.20395 4.17175 2.27996 6.51436 1.14354 9.25562C0.00710557 11.9969 -0.290702 15.0136 0.287789 17.9242C0.86628 20.8347 2.29508 23.5083 4.39341 25.6066C6.49174 27.705 9.16532 29.1337 12.0759 29.7122C14.9864 30.2907 18.0032 29.9929 20.7444 28.8565C23.4857 27.7201 25.8283 25.7961 27.4758 23.328C29.1233 20.8598 30.0018 17.9585 30 14.991C30.0012 13.022 29.6142 11.0721 28.8613 9.25281C28.1083 7.43349 27.0042 5.78041 25.6119 4.38814C24.2196 2.99586 22.5665 1.89168 20.7472 1.13873C18.9279 0.385778 16.978 -0.00118022 15.009 2.70395e-06ZM15.009 26.9946C12.6345 26.9964 10.3129 26.2939 8.3377 24.976C6.36254 23.6581 4.82262 21.784 3.91272 19.5908C3.00281 17.3976 2.76382 14.9838 3.22596 12.6548C3.68811 10.3257 4.83063 8.186 6.50901 6.50637C8.18738 4.82674 10.3262 3.68263 12.6549 3.21874C14.9836 2.75485 17.3976 2.99202 19.5915 3.90027C21.7854 4.80853 23.6606 6.34707 24.98 8.32125C26.2994 10.2954 27.0036 12.6165 27.0036 14.991C26.9989 18.1715 25.7339 21.2206 23.4858 23.4704C21.2376 25.7202 18.1895 26.9875 15.009 26.9946Z"
                fill={themeVar('font.action')}
              />
            </svg>
          )}
        </IconWrapper>
      </ToggleWrapper>
    </ToggleContainer>
  );
};

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
`;

const ToggleTitle = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  color: ${themeVar('font.strong')};
`;

const ToggleWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  cursor: pointer;
  min-width: 44px;
  width: 44px;
  height: 16px;
  background: ${({ isActive }) => (isActive ? themeVar('action.default') : 'transparent')};
  border: 1px solid ${themeVar('action.default')};
  border-radius: 14px;
  padding: 2px;
  transition: all 0.3s ease-in-out;
  position: relative;
`;

const IconWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 12px;
  border: ${({ isActive }) => (isActive ? `1px solid ${themeVar('layer.base')}` : 'none')};
  background-color: ${themeVar('layer.base')};
  transform: ${({ isActive }) => (isActive ? 'translate(21px)' : 'translate(-3px)')};
  position: absolute;
  top: -3px;
  transition: all 0.3s ease-in-out;
`;
